
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos-de-contrato",
      function () {
        return require("private-next-pages/termos-de-contrato/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termos-de-contrato"])
      });
    }
  